import { Logger } from 'services';
import { inImpersonateMode } from 'helpers';

let storage = inImpersonateMode ? sessionStorage : localStorage;

/**
 * Retrives a value from the browser storage
 * @param key
 */
function get(key: string) {
  try {
    const data = storage.getItem(key) || '';
    return data;
  } catch (error) {
    Logger.log(`Error reading ${key} from localStorage`);
  }
}

/**
 * Sets a value on the browser storage
 * @param key
 * @param value
 */
function set(key: string, value: string) {
  return storage.setItem(key, value);
}

/**
 * Removes a value on the browser storage
 * @param key
 */
function remove(key: string) {
  return storage.removeItem(key);
}

/**
 * Clears browser storage
 * @param key
 */
function clear() {
  return storage.clear();
}

const Storage = {
  get,
  set,
  clear,
  remove,
};

export default Storage;
